export var LoginState = /*#__PURE__*/ function(LoginState) {
    LoginState["LOGIN_STATE_UNKNOWN"] = "LOGIN_STATE_UNKNOWN";
    LoginState["LOGIN_OK"] = "LOGIN_OK";
    LoginState["ISSUED_LOGIN_CODE"] = "ISSUED_LOGIN_CODE";
    LoginState["MFA_REQUIRED"] = "MFA_REQUIRED";
    LoginState["SIGN_UP_REQUIRED"] = "SIGN_UP_REQUIRED";
    LoginState["SOCIAL_LOGIN_PASSWORD_REQUIRED"] = "SOCIAL_LOGIN_PASSWORD_REQUIRED";
    LoginState["MFA_METHOD_SELECTION_REQUIRED"] = "MFA_METHOD_SELECTION_REQUIRED";
    /**
   * login code issued by system (e.g. after 3 failed password attempts)
   */ LoginState["ISSUED_AUTOMATIC_LOGIN_CODE"] = "ISSUED_AUTOMATIC_LOGIN_CODE";
    return LoginState;
}({});
